import { Grid, TextField } from "@material-ui/core";
import React, { ReactNode, useMemo, useState } from "react";

import {
  AgencyIcon,
  AlertIcon,
  AssembleiaIcon,
  BackIcon,
  BellIcon,
  BuildingIcon,
  CakeIcon,
  CalendarIcon,
  CalendarFilledIcon,
  ChartIcon,
  ChatIcon,
  CheckIcon,
  ChevronIcon,
  CircleAddIcon,
  CircleCheckIcon,
  CircleCloseIcon,
  ClockIcon,
  CloseIcon,
  ColaboradorIcon,
  CommunityIcon,
  DialogIcon,
  DocumentIcon,
  DigitalWindowIcon,
  DownloadIcon,
  DuvidaIcon,
  EditIcon,
  ErrorIcon,
  ExcelIcon,
  HomeIcon,
  InvertedChevronIcon,
  LockIcon,
  MaletaIcon,
  PeopleIcon,
  PlayIcon,
  PlusIcon,
  PresentationIcon,
  PublicIcon,
  ReplyIcon,
  SearchIcon,
  SecurityIcon,
  SendIcon,
  SyncIcon,
  TipoContaIcon,
  TrashIcon,
  UserIcon,
} from 'components/Icons';

const icons: {
  name: string;
  icon: ReactNode;
}[] = [
  {
    name: 'AgencyIcon',
    icon: <AgencyIcon />,
  },
  {
    name: 'AlertIcon',
    icon: <AlertIcon />,
  },
  {
    name: 'AssembleiaIcon',
    icon: <AssembleiaIcon />,
  },
  {
    name: 'BackIcon',
    icon: <BackIcon />,
  },
  {
    name: 'BellIcon',
    icon: <BellIcon />,
  },
  {
    name: 'BuildingIcon',
    icon: <BuildingIcon />,
  },
  {
    name: 'CakeIcon',
    icon: <CakeIcon />,
  },
  {
    name: 'CalendarIcon',
    icon: <CalendarIcon />,
  },
  {
    name: 'CalendarFilledIcon',
    icon: <CalendarFilledIcon />,
  },
  {
    name: 'ChartIcon',
    icon: <ChartIcon />,
  },
  {
    name: 'ChatIcon',
    icon: <ChatIcon />,
  },
  {
    name: 'CheckIcon',
    icon: <CheckIcon />,
  },
  {
    name: 'ChevronIcon',
    icon: <ChevronIcon />,
  },
  {
    name: 'CircleAddIcon',
    icon: <CircleAddIcon />,
  },
  {
    name: 'CircleCheckIcon',
    icon: <CircleCheckIcon />,
  },
  {
    name: 'CircleCloseIcon',
    icon: <CircleCloseIcon />,
  },
  {
    name: 'ClockIcon',
    icon: <ClockIcon />,
  },
  {
    name: 'CloseIcon',
    icon: <CloseIcon />,
  },
  {
    name: 'ColaboradorIcon',
    icon: <ColaboradorIcon />,
  },
  {
    name: 'CommunityIcon',
    icon: <CommunityIcon />,
  },
  {
    name: 'DialogIcon',
    icon: <DialogIcon />,
  },
  {
    name: 'DocumentIcon',
    icon: <DocumentIcon />,
  },
  {
    name: 'DigitalWindowIcon',
    icon: <DigitalWindowIcon />,
  },
  {
    name: 'DownloadIcon',
    icon: <DownloadIcon />,
  },
  {
    name: 'DuvidaIcon',
    icon: <DuvidaIcon />,
  },
  {
    name: 'EditIcon',
    icon: <EditIcon />,
  },
  {
    name: 'ErrorIcon',
    icon: <ErrorIcon />,
  },
  {
    name: 'ExcelIcon',
    icon: <ExcelIcon />,
  },
  {
    name: 'HomeIcon',
    icon: <HomeIcon />,
  },
  {
    name: 'InvertedChevronIcon',
    icon: <InvertedChevronIcon />,
  },
  {
    name: 'LockIcon',
    icon: <LockIcon />,
  },
  {
    name: 'MaletaIcon',
    icon: <MaletaIcon />,
  },
  {
    name: 'PeopleIcon',
    icon: <PeopleIcon />,
  },
  {
    name: 'PlayIcon',
    icon: <PlayIcon />,
  },
  {
    name: 'PlusIcon',
    icon: <PlusIcon />,
  },
  {
    name: 'PresentationIcon',
    icon: <PresentationIcon />,
  },
  {
    name: 'PublicIcon',
    icon: <PublicIcon />,
  },
  {
    name: 'ReplyIcon',
    icon: <ReplyIcon />,
  },
  {
    name: 'SearchIcon',
    icon: <SearchIcon />,
  },
  {
    name: 'SecurityIcon',
    icon: <SecurityIcon />,
  },
  {
    name: 'SendIcon',
    icon: <SendIcon />,
  },
  {
    name: 'SyncIcon',
    icon: <SyncIcon />,
  },
  {
    name: 'TipoContaIcon',
    icon: <TipoContaIcon />,
  },
  {
    name: 'TrashIcon',
    icon: <TrashIcon />,
  },
  {
    name: 'UserIcon',
    icon: <UserIcon />,
  },
]

export default () => {
  const [busca, setBusca] = useState<string>('');

  const allIcons = useMemo(() => {
    return icons.filter((it) => (it.name.toLowerCase().indexOf(busca.toLowerCase()) > -1 ? true : false));
  }, [busca]);

  return (
    <Grid container alignItems="center" justify="center" spacing={3}>
      <Grid item xs={12}>
        <TextField label="Busca por ícone" value={busca} onChange={(event) => setBusca(event.target!.value)} />
      </Grid>
      {allIcons.length > 0 ? (
        allIcons.map((it) => (
          <Grid item xs={3} lg={2}>
            <Grid container spacing={3}>
              <Grid item xs={12} container justify="center">
                {it.icon}
              </Grid>
              <Grid item xs={12} container justify="center">
                <b>{it.name}</b>
              </Grid>
            </Grid>
          </Grid>
        ))
      ) : (
        <b>Nenhum ícone encontrado</b>
      )}
    </Grid>
  );
};
